import axios from "axios"

import { devMode } from "./base"
const baseDomain = `https://m-car${devMode ? "-dev" : ""}.mioto.vn`
const commonDomain = `https://m-common${devMode ? "-dev" : ""}.mioto.vn`
const map4DKeyApi = '847bd3a139a982d07c03ba07e4ca443c';

export function getLandingPage() {
    return axios({
        withCredentials: true,
        method: "GET",
        url: `${baseDomain}/landingpage`
    })
}
export function getHomePage() {
    return axios({
        withCredentials: true,
        method: "GET",
        url: `${baseDomain}/homepage/sd`
    })
}
export function getHomePageWithDriver() {
    return axios({
        withCredentials: true,
        method: "GET",
        url: `${baseDomain}/homepage/wd`
    })
}
export function getCity(city) {
    return axios({
        withCredentials: true,
        method: "GET",
        url: `${baseDomain}/city/detail/sd?city=${city}`
    })
}
export function getCityWithDriver(city) {
    return axios({
        withCredentials: true,
        method: "GET",
        url: `${baseDomain}/city/detail/wd?city=${city}`
    })
}

export function submitFormOwnerRegister(data) {
    return axios({
        method: "POST",
        url: `${commonDomain}/owner/register?name=${data.name}&phoneNumber=${data.phoneNumber}&city=${data.city}&email=${data.email}&isRental=${data.isRental}&reference=${data.reference}&carName=${data.carName}&stype=${data.stype}`
    })
}


export function searchInHouse(query, lat, lon) {
	// "lat": lat, "lon": lon
	const address = query && query !== "" ? `&address=${query}` : '';
	const pLat = lat ? `&lat=${lat}` : '';
	const pLon = lon ? `&lon=${lon}` : '';

	return axios({
		withCredentials: true,
		method: "GET",
		url: `${commonDomain}/lbs/search-address?sdkMap=2${address}${pLat}${pLon}`
	})
}

export function getRouteMap4D(origin, destination, points) {
	return axios({
		method: "GET",
		url: `https://api.map4d.vn/sdk/route?key=${map4DKeyApi}&mode=car&origin=${origin}&destination=${destination}&points=${points}`
	})
}


// WEBPACK FOOTER //
// ./src/model/common.js